const UserInfoCell = ({ name, employeeId, token }) => {
  if (!name || !employeeId || !token) return "--";

  return (
    <a
      href={`/employee/profile/${token}`}
      target="_blank"
      rel="noreferrer"
      style={{ fontSize: "inherit" }}
    >
      {`${name} (${employeeId})`}
    </a>
  );
};

export default UserInfoCell;
